var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainersMobileNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7533_11895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 0C8.79886 0 8.48438 0.314484 8.48438 0.703125V5.01558C8.48438 5.40422 8.79886 5.7187 9.1875 5.7187C9.57614 5.7187 9.89062 5.40422 9.89062 5.01558V0.703125C9.89062 0.314484 9.57614 0 9.1875 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 3.11223C15.0818 2.83759 14.6368 2.83759 14.3622 3.11223L11.5497 5.92468C11.2751 6.19932 11.2751 6.64431 11.5497 6.91895C11.8244 7.19359 12.2694 7.19364 12.544 6.91895L15.3564 4.1065C15.6311 3.83186 15.6311 3.38687 15.3564 3.11223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87207 5.92468L4.05962 3.11223C3.78498 2.83759 3.34 2.83759 3.06536 3.11223C2.79071 3.38687 2.79071 3.83186 3.06536 4.1065L5.87781 6.91895C6.1525 7.19364 6.59743 7.19364 6.87207 6.91895C7.14672 6.64431 7.14672 6.19932 6.87207 5.92468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2656 14.1562C15.1025 14.1562 14.1562 15.1025 14.1562 16.2656C14.1562 17.4288 15.1025 18.375 16.2656 18.375C17.4288 18.375 18.375 17.4287 18.375 16.2656C18.375 15.1025 17.4288 14.1562 16.2656 14.1562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5435 8.53673L12.0474 8.53125H12.0467C11.86 8.53125 11.6814 8.60541 11.5496 8.73727L10.3494 9.9375H8.07234L6.87211 8.73727C6.74025 8.60541 6.56175 8.53125 6.375 8.53125H0.703125C0.314484 8.53125 0 8.84573 0 9.23438V14.8593C0 15.1821 0.21975 15.4629 0.532828 15.5412L4.19897 16.4462C6.51633 17.0257 8.48152 18.4134 9.59049 20.2529C10.9905 22.5772 13.5656 23.9999 16.2703 23.9999C16.3341 23.9999 16.398 23.9992 16.4611 23.9978C20.583 23.8955 23.9647 20.4569 23.9997 16.3315C24.0347 12.1238 20.7712 8.70014 16.5435 8.53673ZM16.2654 19.7812C14.327 19.7812 12.7499 18.204 12.7499 16.2656C12.7499 14.3272 14.3271 12.75 16.2654 12.75C18.2038 12.75 19.781 14.3272 19.781 16.2656C19.781 18.204 18.2038 19.7812 16.2654 19.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8904 7.125C21.1835 7.125 20.5601 7.4775 20.1772 8.01281C21.4743 8.62289 22.5978 9.5183 23.4659 10.6226C23.794 10.2507 23.9998 9.76819 23.9998 9.23433C23.9998 8.07122 23.0535 7.125 21.8904 7.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7533_11895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainersMobileNav);
export default __webpack_public_path__ + "static/media/trainers-mobile-nav.0c7b6026d5023dcf68ae81797c06d83f.svg";
export { ForwardRef as ReactComponent };